import { render } from "./DepartmentDetails.vue?vue&type=template&id=4b1f6445&scoped=true"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"

import "./DepartmentDetails.vue?vue&type=style&index=0&id=4b1f6445&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1f6445"]])

export default __exports__